exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-new-col{height:150px;margin-left:20px;margin-bottom:15px;width:45px;cursor:pointer;border:1px dashed #000}", ""]);

// exports
